import { Row, Col, Button } from "rsuite";
import { Container } from "react-bootstrap";
import { useOrderCreation, LuggageVarAction } from "../context/OrderCreationContext";
import { LuggageCounter } from "../components/LuggageCounter";

export const LuggageSelection: React.FC = () => {
  const {
    userRegistLuggages,
    setUserRegistLuggages,
    changeLuggageQuantity,
    setStep
  } = useOrderCreation();

  const handleReset = () => {
    let emptyUserRegistLuggage = userRegistLuggages.map(obj => {
      return { ...obj, quantity: 0 };
    });
    setUserRegistLuggages(emptyUserRegistLuggage);
  };

  const handleApply = () => {
    setStep(2);
  };

  return (
    <Container fluid="md" style={{ backgroundColor: 'white' }} className="rounded">
      <br />
      <Row>
        <Col style={{ textAlign: 'left' }}><h5>行李數量</h5></Col>
      </Row>
      <br />

      {userRegistLuggages.map((registluggage, index) => (
        <div key={index}>
          <LuggageCounter
            registLuggage={registluggage}
            onIncrement={() => changeLuggageQuantity(LuggageVarAction.Increase, index)}
            onDecrement={() => changeLuggageQuantity(LuggageVarAction.Decrease, index)}
          />
          <br />
        </div>
      ))}

      <br />
      <br />
      <Row>
        <Col style={{ textAlign: 'right' }} xs={22}>
          <Button appearance="default" style={{ width: '45%' }} onClick={handleReset}>
            全部重置
          </Button>
          &nbsp;&nbsp;
          <Button appearance="default" style={{ width: '45%' }} onClick={handleApply}>
            套用
          </Button>
        </Col>
      </Row>
      <br />
    </Container>
  );
};
